import 'url-polyfill';
import VueResource from 'vue-resource';
import Vue from 'vue';

Vue.use(VueResource);

const urlPrefix = `${window.location.origin}${window.SITE_URL}`;

export default {
  getAgents(params) {
    const query = {};
    Object.keys(params).forEach((filterAttr) => {
      const queryKey = filterAttr.replace(
        /([A-Z])/g,
        m1 => `_${m1.toLowerCase()}`,
      );
      query[queryKey] = params[filterAttr];
    });
    const url = new URL('api/agent/list', urlPrefix);
    return Vue.http.get(url.href, {
      params: query,
    }).then(res => res.json());
  },

  getAgent(emailAlias) {
    const query = {
      emailAlias,
    };
    const url = new URL('api/agent/detail', urlPrefix);
    return Vue.http.get(url.href, {
      params: query,
    }).then(res => res.json());
  },

  getMitaclubMembers() {
    const url = new URL('api/agent/mitaclub_members', urlPrefix);
    return Vue.http.get(url.href).then(res => res.json());
  },

  getDiaMember(emailAlias) {
    const query = {
      emailAlias,
    };
    const url = new URL('api/agent/mitaclub_dia_member', urlPrefix);
    return Vue.http.get(url.href, {
      params: query,
    }).then(res => res.json());
  },
};
